import { render } from "./my_certificate.vue?vue&type=template&id=6492003d&scoped=true"
import script from "./my_certificate.vue?vue&type=script&lang=js"
export * from "./my_certificate.vue?vue&type=script&lang=js"

import "./my_certificate.vue?vue&type=style&index=0&id=6492003d&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6492003d"]])

export default __exports__